import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';
import PregnancyDetails from './pregnancyDetails';

function IUIAnalyticsTable({ iuiDetails, setIuiDetails }) {
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const handleRowClick = (e, item) => {
    setIuiDetails({
      open: true,
      data: item,
    });
  };
  return (
    <>
      {!iuiDetails.open && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 700 }}>Patient Name</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Patient Age</TableCell>
                <TableCell style={{ fontWeight: 700 }}>MPID</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Spouse Name</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Spouse Age</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Date</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  No. of Days Abstinence
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Sample Complete/Incomplete
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Sperm Count</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Total Count</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Motility (%)</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  a. Progressive
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  b. Non-Progressive
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>c. Immotile</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Sperm Washing Procedure
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Volume</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Sperm Count</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Total Motility
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  A. Progressive
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  B.Non Progressive
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>bHcg Report</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Clinical Pregnancy
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Ongoing pregnancy
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Delivery Details
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow
                  sx={{
                    cursor: 'pointer',
                  }}
                  hover
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRowClick(e, item);
                  }}
                >
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.patientName
                      : item.partnerName}
                  </TableCell>
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.patientAge
                      : item.partnerAge}
                  </TableCell>
                  <TableCell>{item.upid}</TableCell>
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.partnerName === ''
                        ? 'N/A'
                        : item.partnerName
                      : item.patientName === ''
                        ? 'N/A'
                        : item.patientName}
                  </TableCell>
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.partnerAge === ''
                        ? 'N/A'
                        : item.partnerAge
                      : item.Age === ''
                        ? 'N/A'
                        : item.Age}
                  </TableCell>
                  <TableCell sx={{ minWidth: '160px' }}>
                    {new Date(item.createdAt).toLocaleDateString('en-uk')}
                  </TableCell>
                  <TableCell>
                    {item.patientDetails.abstinenceDays === ''
                      ? 'N/A'
                      : item.patientDetails.abstinenceDays}
                  </TableCell>
                  <TableCell>{item.patientDetails.sample}</TableCell>
                  <TableCell>
                    {item.spermPrewashfindings?.firstEjaculate?.spermCount ===
                    ''
                      ? 'N/A'
                      : item.spermPrewashfindings?.firstEjaculate?.spermCount ||
                        'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.spermPrewashfindings?.firstEjaculate?.totalCount ===
                    ''
                      ? 'N/A'
                      : item.spermPrewashfindings?.firstEjaculate?.totalCount ||
                        'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.spermPrewashfindings?.firstEjaculate
                      ?.totalMotility === ''
                      ? 'N/A'
                      : item.spermPrewashfindings?.firstEjaculate
                          ?.totalMotility || 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.spermPrewashfindings?.firstEjaculate?.progressive ===
                    ''
                      ? 'N/A'
                      : item.spermPrewashfindings?.firstEjaculate
                          ?.progressive || 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.spermPrewashfindings?.firstEjaculate
                      ?.nonProgressive === ''
                      ? 'N/A'
                      : item.spermPrewashfindings?.firstEjaculate
                          ?.nonProgressive || 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermPrewashfindings?.firstEjaculate?.immotile === ''
                      ? 'N/A'
                      : item?.spermPrewashfindings?.firstEjaculate?.immotile ||
                        'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermPostwashFindings?.spermWashingProcedure === ''
                      ? 'N/A'
                      : item?.spermPostwashFindings?.spermWashingProcedure}
                  </TableCell>
                  <TableCell>
                    {item?.spermPostwashFindings?.volume === ''
                      ? 'N/A'
                      : item?.spermPostwashFindings?.volume}
                  </TableCell>
                  <TableCell>
                    {item?.spermPostwashFindings?.spermCount === ''
                      ? 'N/A'
                      : item?.spermPostwashFindings?.spermCount}
                  </TableCell>
                  <TableCell>
                    {item?.spermPostwashFindings?.totalMotility === ''
                      ? 'N/A'
                      : item?.spermPostwashFindings?.totalMotility}
                  </TableCell>
                  <TableCell>
                    {item?.spermPostwashFindings?.progressive === ''
                      ? 'N/A'
                      : item?.spermPostwashFindings?.progressive}
                  </TableCell>
                  <TableCell>
                    {item?.spermPostwashFindings?.nonProgressive === ''
                      ? 'N/A'
                      : item?.spermPostwashFindings?.nonProgressive}
                  </TableCell>
                  <TableCell>
                    {item.pregnancyDetails
                      ? item.pregnancyDetails.bHcgReport === ''
                        ? 'N/A'
                        : item.pregnancyDetails.bHcgReport
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.pregnancyDetails
                      ? item.pregnancyDetails.clinicalPregnancy === ''
                        ? 'N/A'
                        : item.pregnancyDetails.clinicalPregnancy
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.pregnancyDetails
                      ? item.pregnancyDetails.onGoingPregnancy === ''
                        ? 'N/A'
                        : item.pregnancyDetails.onGoingPregnancy
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.pregnancyDetails
                      ? item.pregnancyDetails.deliveryDetails === ''
                        ? 'N/A'
                        : item.pregnancyDetails.deliveryDetails
                      : 'N/A'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {iuiDetails.open && (
        <PregnancyDetails
          setIsPregnancyDetails={() => {}}
          selectedPatientData={null}
          selectedIuiIdForPregnancyDetails={iuiDetails.data.id}
          dataAnalyticsData={iuiDetails.data}
          setIuiDetails={setIuiDetails}
        />
      )}
    </>
  );
}

export default IUIAnalyticsTable;
